import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Skeleton as SkeletonUI } from '@alfalab/core-components-skeleton';

import { Skeleton as Component } from './skeleton';
import type { TSkeleton, IDeps } from './models';
import styles from './styles/styles.css';

export const Skeleton = createWidget<IDeps, TSkeleton>(
    { SkeletonUI, styles },
    { priorityStyler: true }
)(Component);
